module.exports = __webpack_public_path__ + "img/world.26b32038.png";